// Global Variables
let productJSONCollection = [];
let paginationIndex = 0;
let paginateBy = 0;

(function($) {
    // On Initial Load Grab Products From Page And Make JSON Array
    $(document).on('DOMContentLoaded', function() {
        $('.product-json').each(function() {
            productJSONCollection.push(JSON.parse($(this).html()));
        });
    });

    // When Everything Is Loaded
    $(document).ready(function() {
        initProductManagement();
    });
})(jQuery);

/*
 * -- HTML Generators --
 */
function initProductManagement() {
    paginateBy = (parseInt($('#SectionSettings').data('products-per-row')) * parseInt($('#SectionSettings').data('rows-per-page'))) - 1;

    // Initial Product Grid
    buildProductGrid(productJSONCollection, paginationIndex, paginateBy);
    paginationIndex += paginateBy;

    // Sort Out Tags To Create Filter HTML
    let collectionTags = JSON.parse($('#CollectionTags').html());
    let filterData = {};

    for (let i = 0; i < collectionTags.length; i++) {
        let filterDataParsed = parseFilterInfo(collectionTags[i]);

        if (filterDataParsed !== undefined) {
            let filterCategory = filterDataParsed[0];
            let filterValue = filterDataParsed[1];

            filterCategory = filterCategory.toLowerCase();
            filterData[filterCategory] === undefined ? filterData[filterCategory] = [filterValue.toLowerCase()] : filterData[filterCategory].push(filterValue.toLowerCase());
        }
    }

    // Append Filter HTML
    $('.filter-categories').eq(0).append(buildProductFilters(filterData));

    // Control: Infinite Scroll
    $(window).scroll(function() {
        if($(window).scrollTop() + $(window).height() > $(document).height() - 1000 && $('.grid__item').length !== 0 && !areFiltersActive()) {
            if (paginationIndex < productJSONCollection.length) {
                buildProductGrid(productJSONCollection, paginationIndex, paginateBy);
                paginationIndex += paginateBy;

                $('.grid-view-item__link').mouseenter(function() {
                    let secondImgUrl = $(this).data('secondaryImg');
                    if (secondImgUrl !== 'undefined') {
                        let imgElement = $(this).children().eq(0);
                        imgElement.attr('src', secondImgUrl);
                    }
                }).mouseleave(function() {
                    let firstImgUrl = $(this).data('primaryImg');
                    if (firstImgUrl !== 'undefined') {
                        let imgElement = $(this).children().eq(0);
                        imgElement.attr('src', firstImgUrl);
                    }
                });
            }
        }
    });

    // Control: Dropdowns & Slideouts
    $('#SlideoutTrigger').on('click', function() {
        // Transition Filter Icon
        let filterIcon = $('#FilterIcons > i');
        filterIcon[0].style.transform === '' || filterIcon[0].style.transform === 'rotate(0deg)' ? filterIcon.css({'transform': 'rotate(45deg)'}) : filterIcon.css({'transform': 'rotate(0deg)'});

        // Slide Out Filters
        let filterSortWrapper = $(this).siblings();
        !filterSortWrapper.hasClass('is-active') ? filterSortWrapper.addClass('is-active') : filterSortWrapper.removeClass('is-active');

        // Special Case
        if ($(window).width() <= 500) {
            let artistDropdown = $('#Artists');
            if (artistDropdown.hasClass('is-active')) {
                artistDropdown[0].style.transform === '' ? artistDropdown[0].style.transform = 'translate3d(-250px, 0px, 0px)' : artistDropdown[0].style.transform = '';
            }
        }
    });
    $('#SlidedownTrigger').on('click', function() {
        // Transition Filter Icon
        let filterIcon = $(this).siblings().children().eq(0).children().eq(0);
        filterIcon[0].style.transform === '' || filterIcon[0].style.transform === 'rotate(0deg)' ? filterIcon.css({'transform': 'rotate(90deg)'}) : filterIcon.css({'transform': 'rotate(0deg)'});

        // Slide Out Filters
        let artistFilters = $('#Artists');
        !artistFilters.hasClass('is-active') ? artistFilters.addClass('is-active') : artistFilters.removeClass('is-active');
    });
    $('.legend-title').on('click', function() {
        let filterIcon = $(this).children(0);
        let fieldSet = $(this).parent();
        let fieldSetChildren = fieldSet.children();

        if (fieldSet.hasClass('is-hidden')) {
            fieldSet.removeClass('is-hidden');
            fieldSetChildren.each(function() {
                if (!$(this).is('legend')) {
                    $(this).css({'display': 'initial'});
                }
            });
            filterIcon[0].style.transform === '' || filterIcon[0].style.transform === 'rotate(0deg)' ? filterIcon.css({'transform': 'rotate(-90deg)'}) : filterIcon.css({'transform': 'rotate(0deg)'});
        }
        else {
            fieldSet.addClass('is-hidden');
            fieldSetChildren.each(function() {
                if (!$(this).is('legend')) {
                    $(this).css({'display': 'none'});
                }
            });
            filterIcon[0].style.transform === '' || filterIcon[0].style.transform === 'rotate(0deg)' ? filterIcon.css({'transform': 'rotate(-90deg)'}) : filterIcon.css({'transform': 'rotate(0deg)'});
        }
    });
    $('.artist-dropdown > div:nth-child(n) > p').on('click', function() {
        let filterIcon = $(this).children().eq(0);
        let artistFields = $(this).parent().children().eq(1);

        filterIcon[0].style.transform === '' || filterIcon[0].style.transform === 'rotate(0deg)' ? filterIcon.css({'transform': 'rotate(-90deg)'}) : filterIcon.css({'transform': 'rotate(0deg)'});
        artistFields.hasClass('not-active') ? artistFields.removeClass('not-active') : artistFields.addClass('not-active');
    });

    // Control Filter Interactions
    bindFilterListeners();
    $('#ClearFilters').on('click', function() {
        $('.filter-list').each(function() {
            let fieldset = $(this).children();
            fieldset.each(function() {
                if ($(this).is('input')) {
                    $(this).prop('checked', false);
                }
            });
        });

        $('.artist-fieldset').each(function() {
            let fieldset = $(this).children();
            fieldset.each(function() {
                if ($(this).is('input')) {
                    $(this).prop('checked', false);
                }
            });
        });

        // Clear & Rebuild Product Grid
        clearProductGrid();
        buildProductGrid(productJSONCollection, paginationIndex, paginateBy);
        paginationIndex += paginateBy;
    });

    // Control: Search
    $('#ArtistSearch').on('keyup', function() {
        let searchValue = $(this).children().eq(0).val().toLowerCase();

        // Show Search Results & Hide Artist Accordions or Vice-Versa
        if ($('#ArtistSearch > input').val().length === 0) {
            $('.artist-dropdown').css({'display': 'block'});
            $('#ArtistSearchResults').css({'display': 'none'});
        } else {
            $('.artist-dropdown').css({'display': 'none'});
            $('#ArtistSearchResults').css({'display': 'block'});
        }

        clearSearchResults();

        // Append Search Results
        $('.artist-list').each(function() {
            let artistFields = $(this).children().eq(0).children();
            artistFields.each(function() {
                let artistField = $(this);

                if (artistField.is('input')) {
                    let fieldsetHTML = $('#ArtistSearchResults > fieldset');
                    let artistFieldVal = artistField.val().toLowerCase();

                    if ($('#ArtistSearch > input').val().length !== 0 && !searchResultsContains(artistFieldVal)) {
                        if (artistFieldVal === searchValue) {
                            fieldsetHTML.append('<input type="checkbox" id="' + artistFieldVal + ' searched' + '" name="' + artistFieldVal + '" value="' + artistFieldVal + '">');
                            fieldsetHTML.append('<label class="filter-styles" for="' + artistFieldVal + ' searched' + '" aria-hidden="true">' + artistFieldVal + '</label>');
                            fieldsetHTML.append('<br>');
                        } else if (artistFieldVal.includes(searchValue)) {
                            fieldsetHTML.append('<input type="checkbox" id="' + artistFieldVal + ' searched' + '" name="' + artistFieldVal + '" value="' + artistFieldVal + '">');
                            fieldsetHTML.append('<label class="filter-styles" for="' + artistFieldVal + ' searched' + '" aria-hidden="true">' + artistFieldVal + '</label>');
                            fieldsetHTML.append('<br>');
                        }
                    }
                }
            });
        });

        bindFilterListeners();
    });

    // Product Card Hover
    bindProductHoverListener();
}

function buildProductFilters(filterData) {
    let filterHTML = '';
    // Build Product Price Filters
    filterHTML += '<div class="product-filters">';
    filterHTML += '<fieldset class="filter-list">';
    filterHTML += '<legend class="legend-title">PRODUCT PRICES<i class="filter-dropdown fas fa-chevron-down" aria-hidden="true"></i></legend>';
    filterHTML += '<input type="checkbox" name="100" value="100" id="100">';
    filterHTML += '<label class="filter-styles" for="100" aria-hidden="true">$0-$100</label></br>';

    filterHTML += '<input type="checkbox" name="1000" value="1000" id="1000">';
    filterHTML += '<label class="filter-styles" for="1000" aria-hidden="true">$100-$1,000</label></br>';

    filterHTML += '<input type="checkbox" name="10000" value="10000" id="10000">';
    filterHTML += '<label class="filter-styles" for="10000" aria-hidden="true">$1,000-$10,000</label></br>';

    filterHTML += '<input type="checkbox" name="100000" value="100000" id="100000">';
    filterHTML += '<label class="filter-styles" for="100000" aria-hidden="true">$10,000-$100,000</label></br>';

    filterHTML += '<input type="checkbox" name="100001" value="100001" id="100001">';
    filterHTML += '<label class="filter-styles" for="100001" aria-hidden="true">$100,000+</label></br>';
    filterHTML += '</fieldset>';
    filterHTML += '</div>';


    // Build Artist Filters & All Other Filters
    let artistFilterHTML = '';
    for (const [filterCategory, filterValues] of Object.entries(filterData)) {
        // Creating Artist HTML Dropdown
        if (filterCategory === 'artist') {
            artistFilterHTML += '<div class="product-filters">';
            artistFilterHTML += '<form id="ArtistSearch">';
            artistFilterHTML += '<input type="search" class="artist-search" name="Artist Search" placeholder="Search Artists">';
            artistFilterHTML += '<i class="fas fa-search" aria-hidden="true"></i>';
            artistFilterHTML += '</form>';

            artistFilterHTML += '<div class="artist-dropdown">';
            artistFilterHTML += '<div>' +
                '<p class="artist-accordion">A-E <i class="fas fa-chevron-down"></i></p>' +
                '<div class="artist-list">' +
                '<fieldset class="artist-fieldset" id="A-E"><legend style="display: none;" class="legend-title">ARTISTS</legend></fieldset>' +
                '</div>' +
                '</div>';

            artistFilterHTML += '<div>' +
                '<p class="artist-accordion">F-M <i class="fas fa-chevron-down"></i></p>' +
                '<div class="artist-list">' +
                '<fieldset class="artist-fieldset" id="F-M"><legend style="display: none;" class="legend-title">ARTISTS</legend></fieldset>' +
                '</div>' +
                '</div>';

            artistFilterHTML += '<div>' +
                '<p class="artist-accordion">N-S <i class="fas fa-chevron-down"></i></p>' +
                '<div class="artist-list">' +
                '<fieldset class="artist-fieldset" id="N-S"><legend style="display: none;" class="legend-title">ARTISTS</legend></fieldset>' +
                '</div>' +
                '</div>';

            artistFilterHTML += '<div>' +
                '<p class="artist-accordion">T-V <i class="fas fa-chevron-down"></i></p>' +
                '<div class="artist-list">' +
                '<fieldset class="artist-fieldset" id="T-V"><legend style="display: none;" class="legend-title">ARTISTS</legend></fieldset>' +
                '</div>' +
                '</div>';

            artistFilterHTML += '<div>' +
                '<p class="artist-accordion">W-Z <i class="fas fa-chevron-down"></i></p>' +
                '<div class="artist-list">' +
                '<fieldset class="artist-fieldset" id="W-Z"><legend style="display: none;" class="legend-title">ARTISTS</legend></fieldset>' +
                '</div>' +
                '</div>';
            artistFilterHTML += '</div>';
            artistFilterHTML += '</div>';

            $('#Artists').append(artistFilterHTML);

            // Populate Artist Options
            let artistDropdown = '';
            for (let i = 0; i < filterValues.length; i++) {
                let filterValue = filterValues[i];
                let charCode = filterValue.toLowerCase().charCodeAt(0);

              	artistDropdown += '<input type="checkbox" name="' + filterValue + '" value="' + filterValue + '" id="' + filterValue + '">';
              	artistDropdown += '<label class="filter-styles" for="' + filterValue + '" aria-hidden="true">' + filterValue + '</label></br>';

                if (charCode >= 97 && charCode <= 101) {
                    $('#A-E').append(artistDropdown);
                } else if (charCode >= 102 && charCode <= 109) {
                    $('#F-M').append(artistDropdown);
                } else if (charCode >= 110 && charCode <= 115) {
                    $('#N-S').append(artistDropdown);
                } else if (charCode >= 116 && charCode <= 119) {
                    $('#T-V').append(artistDropdown);
                } else {
                    $('#W-Z').append(artistDropdown);
                }

                artistDropdown = '';
            }

            artistDropdown = '';
            artistDropdown += '<div class="artist-dropdown" id="ArtistSearchResults" >';
            artistDropdown += '<fieldset class="artist-search-results artist-fieldset">';
            artistDropdown += '<legend class="legend-title">SEARCH RESULTS</legend>';
            artistDropdown += '</fieldset>';
            artistDropdown += '</div>';

            $('#Artists > div').append(artistDropdown);

            // Close All Artist Accordions
            $('.artist-list').each(function() {
                let artistDropdownDiv = $(this).parent();
                let artistList = $(this).children().eq(0).children();

                let filterIcon = artistDropdownDiv.children().eq(0).children().eq(0);
                artistList = artistDropdownDiv.children().eq(1);
                artistList.addClass('not-active');
                filterIcon[0].style.transform === 'rotate(0deg)' || filterIcon[0].style.transform === '' ? filterIcon.css({'transform': 'rotate(-90deg)'}) : filterIcon.css({'transform': 'rotate(0deg)'});
            });
        }

        // Creating Other HTML Filters
        else {
            filterHTML += '<div class="product-filters">';
            filterHTML += '<fieldset class="filter-list">';
            filterHTML += '<legend class="legend-title">' + filterCategory.toUpperCase() + '<i class="fas fa-chevron-down" aria-hidden="true"></i></legend>';
            for (let i = 0; i < filterValues.length; i++) {
                let filterValue = filterValues[i];
                filterHTML += '<input id="' + filterValue + '" type="checkbox" name="' + filterValue + '" value="' + filterValue + '">';
                filterHTML += '<label class="filter-styles" for="' + filterValue + '" aria-hidden="true">' + filterValue + '</label></br>';
            }
            filterHTML += '</fieldset>';
            filterHTML += '</div>';
        }
    }

    return filterHTML;
}

function buildProductGrid(productJSONCollection, paginationIndex, paginateBy) {
    let sectionSettings = $('#SectionSettings');
    let sectionID = sectionSettings.data('section-id');
    let gridItemWidth = sectionSettings.data('grid-item-width');

    let formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    let max = 0;
    max = paginationIndex === 0 ? paginateBy : (paginationIndex + paginateBy);

    for (let i = paginationIndex; i < max; i++) {
        if (productJSONCollection[i] !== undefined) {
            // console.log(productJSONCollection[i]);
            // Product Meta Data
            let showVendor = sectionSettings.data('show-vendor');
            let productVendor = showVendor ? productJSONCollection[i].vendor : ''
            let productTitle = productJSONCollection[i].title
            let imgURL = productJSONCollection[i].images.length === 0 ? 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1024x900.gif' : productJSONCollection[i].images[0];
            let secondImgURL = productJSONCollection[i].images[1] !== undefined ? productJSONCollection[i].images[1] : 'undefined';
            let hideDetails = sectionSettings.data('hide-details');
            let showOnSale = sectionSettings.data('show-on-sale');
            let disableLink = sectionSettings.data('disable-link');
            let showPrice = sectionSettings.data('show-price');
            let productURL = 'https://artwareeditions.com/products';
            productURL += '/' + productJSONCollection[i].handle;

            // Money Variables
            let productPrice = productJSONCollection[i].price;
            let moneyPrice = formatter.format(productPrice/100);
            let priceVaries = productJSONCollection[i].priceVaries;
            let productAvailable = productJSONCollection[i].available;
            let compareAtPrice = productJSONCollection[i].compare_at_price;
               
            let badge = false;
            let badge2 = false;
            let tags = productJSONCollection[i].tags;
            for (let j = 0; j < tags.length; j++) {
                tagSplit = tags[j].split('_');
                if( tagSplit[0] == 'badge' && tagSplit.length == 2 ){
                    badge = tagSplit[1];
                }
                if( tagSplit[0] == 'badge2' && tagSplit.length == 2 ){
                    badge2 = tagSplit[1];
                }
            }


            let html = '';
            html += '<div class="grid__item grid__item--' + sectionID + ' ' + gridItemWidth + '">';
                html += !productAvailable ? '<div class="grid-view-item product-price--sold-out grid-view-item--sold-out">' : '<div class="grid-view-item">';
                    html += disableLink ? '<div' : '<a href="'+ productURL +'"';
                    html += ' class="grid-view-item__link relative" data-primary-img="' + imgURL + '" data-secondary-img="' + secondImgURL + '">';
                        html += '<img class="lazyload grid-view-item__image" src="' + imgURL + '" alt="Product Featured Image">';
                        html += badge ? '<div class="on-sale-banner '+ badge.replace(/[^a-z0-9]/gi, '').toLowerCase() +'">'+ badge +'</div>' : '';
                        html += badge2 ? '<div class="relative"><div class="badge_2 '+ badge2.replace(/[^a-z0-9]/gi, '').toLowerCase() +'">'+ badge2 +'</div></div>' : '';
                        html += '<div class="h4 grid-view-item__title">' + productTitle + '</div>';
                        html += productAvailable === true ? '<div class="grid-view-item__vendor">' + productVendor + '</div>' : '';
                        html += '<div class="grid-view-item__meta">';
                            if (productPrice !== 0.00 && showPrice ) {
                                if (compareAtPrice !== null) {
                                    html += !priceVaries ? '<span class="visually-hidden">' + moneyPrice + ' </span>' : '';
                                    html += !productAvailable ? '<s class="product-price__price">' + formatMoney(compareAtPrice/100)  + ' </s><s class="product-price__price">' + moneyPrice + ' </s><span class="product-price__sold-out">' + ' Sold Out ' + '</span>' : '<s class="product-price__price">' + formatMoney(compareAtPrice/100) + ' </s><span class="product-price__price">' + moneyPrice + ' </span>';
                                } else {
                                    html += !priceVaries ? '<span class="visually-hidden">' + moneyPrice + ' </span>' : '';
                                    html += !productAvailable ? '' : '<span class="product-price__price">' + moneyPrice + ' </span>';
                                }
                            }
                            if (hideDetails !== true) {
                                html += disableLink ? '<div' : '<a href="'+ productURL +'"';
                                html += ' class="link-hover grid-view-item__link">';
                                    html += productPrice !== 0.00 && showPrice ? '<span style="padding-left: .5em; white-space: nowrap; float: right;">details ' : '<span style="white-space: nowrap; float: right;">details ';
                                    html += '</span>';
                                html += disableLink ? '</div>' : '</a>';
                            }
                        html += '</div>';
                    html += disableLink ? '</div>' : '</a>';
                html += '</div>';
            html += '</div>';

            $('.grid').append(html);
        }
    }

    bindProductHoverListener();
}

function buildProductCard(productJSON) {
    let sectionSettings = $('#SectionSettings');
    let sectionID = sectionSettings.data('section-id');
    let gridItemWidth = sectionSettings.data('grid-item-width');

    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    if (productJSON !== undefined) {
        console.log(productJSON);
        // Product Meta Data
        let showVendor = sectionSettings.data('show-vendor');
        let productVendor = showVendor ? productJSON.vendor : ''
        let productTitle = productJSON.title
        let imgURL = productJSON.images.length === 0 ? 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1024x900.gif' : productJSON.images[0];
        let secondImgURL = productJSON.images.length === 0 ? 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1024x900.gif' : productJSON.images[1];
        let hideDetails = sectionSettings.data('hide-details');
        let showOnSale = sectionSettings.data('show-on-sale');
        let disableLink = sectionSettings.data('disable-link');
        let productURL = 'https://artwareeditions.com/products';
        let compareAtPrice = productJSON.compare_at_price
        productURL += '/' + productJSON.handle;

        // Money Variables
        let productPrice = productJSON.price;
        let moneyPrice = formatter.format(productPrice/100);
        let productAvailable = productJSON.available;
        let priceVaries = productJSON.priceVaries;

        let badge = false;
        let badge2 = false;
        let tags = productJSON[i].tags;
        for (let j = 0; j < tags.length; j++) {
            tagSplit = tags[j].split('_');
            if( tagSplit[0] == 'badge' && tagSplit.length == 2 ){
                badge = tagSplit[1];
            }
            if( tagSplit[0] == 'badge2' && tagSplit.length == 2 ){
                badge2 = tagSplit[1];
            }
        }

        let html = '';
        html += '<div class="grid__item grid__item--' + sectionID + ' ' + gridItemWidth + '">';
        html += !productAvailable ? '<div class="grid-view-item product-price--sold-out grid-view-item--sold-out">' : '<div class="grid-view-item">';
        
        html += disableLink ? '<div' : '<a href="'+ productURL +'"';
        html += ' class="grid-view-item__link" data-primary-img="' + imgURL + '" data-secondary-img="' + secondImgURL + '">';
        html += '<div class="relative">';
            html += '<img class="lazyload grid-view-item__image" src="' + imgURL + '" alt="Product Featured Image">';
            html += badge ? '<div class="on-sale-banner '+ badge.replace(/[^a-z0-9]/gi, '').toLowerCase() +'">'+ badge +'</div>' : '';
            html += badge2 ? '<div class="badge_2 '+ badge2.replace(/[^a-z0-9]/gi, '').toLowerCase() +'">'+ badge2 +'</div>' : '';
        html += '</div>';
            html += '<div class="h4 grid-view-item__title">' + productTitle + '</div>';
            html += productAvailable === true ? '<div class="grid-view-item__vendor">' + productVendor + '</div>' : '';
            html += '<div class="grid-view-item__meta">';
            if (productPrice !== 0.00 && showPrice) {
                if (compareAtPrice !== null) {
                    html += !priceVaries ? '<span class="visually-hidden">' + moneyPrice + ' </span>' : '';
                    html += !productAvailable ? '<s class="product-price__price">' + formatMoney(compareAtPrice/100)  + ' </s><s class="product-price__price">' + moneyPrice + ' </s><span class="product-price__sold-out">' + ' Sold Out ' + '</span>' : '<s class="product-price__price">' + formatMoney(compareAtPrice/100) + ' </s><span class="product-price__price">' + moneyPrice + ' </span>';
                } else {
                    html += !priceVaries ? '<span class="visually-hidden">' + moneyPrice + ' </span>' : '';
                    html += !productAvailable ? '' : '<span class="product-price__price">' + moneyPrice + ' </span>';
                }
            }
            if (hideDetails !== true) {
                html += disableLink ? '<div' : '<a href="'+ productURL +'"';
                html += ' class="link-hover grid-view-item__link">';
                html += productPrice !== 0.00 && showPrice ? '<span style="padding-left: .5em; white-space: nowrap; float: right;">details ' : '<span style="white-space: nowrap; float: right;">details ';
                // html += '<i style="color: #FFF; vertical-align: -2px;" class="fal fa-long-arrow-right fa-md"></i>';
                html += '</span>';
                html += disableLink ? '</div>' : '</a>';
            }
            html += '</div>';
        html += disableLink ? '</div>' : '</a>';
        html += '</div>';
        html += '</div>';

        $('.grid').append(html);
    }
}

/*
 * -- Helper Functions --
 */
function applyFilters() {
    clearProductGrid();

    // Variables
    let activeFilters = {};
    let currentKey = '';

    // Check All Selected Filters
    $('.filter-list').children().each(function() {
        let filterFieldsetChildren = $(this);
        let filterValue = filterFieldsetChildren.val();
        let filterCategory = filterFieldsetChildren.text().toLowerCase();

        if (filterFieldsetChildren.is('legend')) {
            if (activeFilters[filterCategory] === undefined) {
                activeFilters[filterCategory] = [];
                currentKey = filterCategory;
            }
        } else {
            if (filterFieldsetChildren.is(':checked') && filterValue != '') {
                activeFilters[currentKey].push(filterValue);
            }
        }
    });

    // Check All Selected Artist's
    currentKey = '';
    $('.artist-fieldset').children().each(function() {
        let artistFieldsetChildren = $(this);
        let filterValue = artistFieldsetChildren.val();
        let filterCategory = artistFieldsetChildren.text().toLowerCase();

        if (artistFieldsetChildren.is('legend')) {
            if (activeFilters[filterCategory] === undefined && filterCategory !== 'search results') {
                activeFilters[filterCategory] = [];
                currentKey = filterCategory;
            }
        } else {
            if (artistFieldsetChildren.is(':checked') && filterValue !== '') {
                activeFilters[currentKey].push(filterValue);
            }
        }
    });

    // console.log(activeFilters);

    for (let i = 0; i < productJSONCollection.length; i++) { // Loop Through Products
        let product = productJSONCollection[i];
        let productFilters = parseProductFilters(product);
        let displayProduct = false;

        for (const [filterCategory, filterValues] of Object.entries(activeFilters)) { // Loop through dictionary with active filters
            let keyedProductFilters = productFilters[filterCategory];
            let filterCategoryPass = false;
            let filterByPrice = parseFloat(product.price/100);

            if (activeFilters['artists'].length !== 0 && activeFilters['product prices'].length !== 0) { // Artist & Product Price Filters Selected
                if (productFilters['artists'] === undefined || productFilters['product prices'] === undefined) {
                    break;
                } else {
                    for (let j = 0; j < filterValues.length; j++) {
                        if (productFilters['artists'].includes(filterValues[j])) {
                            if ((activeFilters['product prices'].includes('100') && (filterByPrice >= 0 && filterByPrice <= 100))
                                || (activeFilters['product prices'].includes('1000') && (filterByPrice >= 100 && filterByPrice <= 1000))
                                || (activeFilters['product prices'].includes('10000') && (filterByPrice >= 1000 && filterByPrice <= 10000))
                                || (activeFilters['product prices'].includes('100000') && (filterByPrice >= 10000 && filterByPrice <= 100000))
                                || (activeFilters['product prices'].includes('100001') && filterByPrice > 100000)) {
                                filterCategoryPass = true;
                            }
                        }
                    }
                }
            }

            /*
            else if (activeFilters['artists'].length !== 0 && filterCategory !== 'product prices' && filterCategory !== 'artists' && filterValues.length !== 0) {
                console.log('Checking Artists & ' + filterCategory);

                if (keyedProductFilters !== undefined) {
                    for (let j = 0; j < filterValues.length; j++) {
                        if (productFilters['artists'].includes(filterValues[j])) {
                            for (let j = 0; j < filterValues.length; j++) {
                                if (keyedProductFilters.includes(filterValues[j])) {
                                    filterCategoryPass = true;
                                }
                            }
                        }
                    }
                }
            }

            else if (activeFilters['product prices'].length !== 0 && filterCategory !== 'product prices' && filterCategory !== 'artists' && filterValues.length !== 0) {
                console.log('Checking Product Prices & ' + filterCategory);

                if (keyedProductFilters !== undefined) {
                    if (productFilters['artists'].includes(filterValues[j])) {
                        if ((activeFilters['product prices'].includes('100') && (filterByPrice >= 0 && filterByPrice <= 100))
                            || (activeFilters['product prices'].includes('1000') && (filterByPrice >= 100 && filterByPrice <= 1000))
                            || (activeFilters['product prices'].includes('10000') && (filterByPrice >= 1000 && filterByPrice <= 10000))
                            || (activeFilters['product prices'].includes('100000') && (filterByPrice >= 10000 && filterByPrice <= 100000))
                            || (activeFilters['product prices'].includes('100001') && filterByPrice > 100000)) {
                                for (let j = 0; j < filterValues.length; j++) {
                                    if (keyedProductFilters.includes(filterValues[j])) {
                                        filterCategoryPass = true;
                                    }
                                }
                        }
                    }
                }
            }
            */
            else {
                if (keyedProductFilters !== undefined) {
                    if (filterCategory === 'product prices') { // Product Price Check
                        let filterByPrice = parseFloat(product.price/100);

                        if ((filterValues.includes('100') && (filterByPrice >= 0 && filterByPrice <= 100))
                            || (filterValues.includes('1000') && (filterByPrice >= 100 && filterByPrice <= 1000))
                            || (filterValues.includes('10000') && (filterByPrice >= 1000 && filterByPrice <= 10000))
                            || (filterValues.includes('100000') && (filterByPrice >= 10000 && filterByPrice <= 100000))
                            || (filterValues.includes('100001') && filterByPrice > 100000)) {
                            filterCategoryPass = true;
                        }
                    } else { // Other Filter's Check
                        for (let j = 0; j < filterValues.length; j++) {
                            if (keyedProductFilters.includes(filterValues[j])) {
                                filterCategoryPass = true;
                            }
                        }
                    }
                }
            }

            if (filterCategoryPass === true) {
                displayProduct = true;
            }
        }

        // Product Has Passed - Display It
        if (displayProduct) {
            buildProductCard(product);
        }
    }

    if ($('#Collection > div.grid.grid--uniform.grid--view-items').children().length === 0) {
        $('.grid').append('<div id="NoProductsFound"><h3 style="height: 2em;">No products found...</h3></div>');
    } else { // Product Card Hover
        bindProductHoverListener();
    }
}

function areFiltersActive() {
    let activeOrNot = false;
    $('.filter-list').each(function() {
        let fieldset = $(this).children();
        fieldset.each(function() {
            if ($(this).is('input') && $(this)[0].checked === true) {
                activeOrNot = true;
            }
        });
    });

    $('.artist-fieldset').each(function() {
        let fieldset = $(this).children();
        fieldset.each(function() {
            if ($(this).is('input') && $(this)[0].checked === true) {
                activeOrNot = true;
            }
        });
    });

    return activeOrNot;
}

function parseFilterInfo(tag) {
    if (tag.toLowerCase().includes('filter_')) {
        let rawFilterCategoryStr = tag.substring(tag.indexOf("_")+1, tag.length);
        let filterCategory = '';
        let filterValue = '';

        // Parse Category From Tag
        for (let j = 0; j < rawFilterCategoryStr.length; j++) {
            if (rawFilterCategoryStr[j] !== '_') {
                filterCategory += rawFilterCategoryStr[j];
            } else {
                // Parse Category Item Value From Tag
                for (let k = j; k < rawFilterCategoryStr.length; k++) {
                    if (rawFilterCategoryStr[k] !== '_')
                        filterValue += rawFilterCategoryStr[k];
                }
                break;
            }
        }

        return (filterCategory.toLowerCase() + ',' + filterValue.toLowerCase()).split(',');
    }
}

function parseProductFilters(product) {
    let productTags = product.tags;
    let productFilters = {};

    for (let j = 0; j < productTags.length; j++) {
        let thisProductFilterTags = parseFilterInfo(productTags[j]);

        if (thisProductFilterTags !== undefined) {
            let productCategoryFilter = thisProductFilterTags[0] === 'artist' ? (thisProductFilterTags[0] + 's') : (thisProductFilterTags[0]);
            let productValueFilter = thisProductFilterTags[1];

            if (productFilters[productCategoryFilter] === undefined) {
                productFilters[productCategoryFilter] = [productValueFilter];
            } else {
                productFilters[productCategoryFilter].push(productValueFilter);
            }
        }
    }

    productFilters['product prices'] = product.price === '' ? 0 : [product.price];

    return productFilters;
}

function bindFilterListeners() {
    let filtersFunction = function() {
        applyFilters();

        if (!areFiltersActive()) {
            clearProductGrid();
            buildProductGrid(productJSONCollection, paginationIndex, paginateBy);
            paginationIndex += paginateBy;
        }
    }

    $('.artist-fieldset > input').on('click', function() {
        filtersFunction();
    });

    $('.filter-categories > div:nth-child(n) > fieldset > input:nth-of-type(n)').on('click', function() {
        filtersFunction()
    });
}

function clearProductGrid() {
    paginationIndex = 0;

    $('#NoProductsFound').remove();

    $('.grid__item').each(function() {
        $(this).remove();
    });
}

function clearSearchResults() {
    let filter = $('#ArtistSearchResults > fieldset').children();

    filter.each(function() {
        if (!$(this).is('legend'))
            $(this).remove();
    });
}

function searchResultsContains(search) {
    let searchResults = $('#ArtistSearchResults > fieldset').children();
    let returnValue = false;

    searchResults.each(function() {
        if ($(this).is('input')) {
            if ($(this).val().toLowerCase().includes(search)) {
                returnValue = true;
            }
        }
    });

    return returnValue;
}
